import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SiteMapService {
  constructor(private http: HttpClient) {}

  getConcession() {
    return this.http.get<any>(
      `${environment.apiUrl}/api/concessions/liste`
    );
  }

  getDataPropsVente() {
    return this.http.get<any>(
      `${environment.apiUrl}/api/biens-liste/vente/?`
    );
  }

  getDataPropsLOcation() {
    return this.http.get<any>(
      `${environment.apiUrl}/api/biens-liste/location/?`
    );
  }
}
